/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PushSubscriptionDto } from '../../models/push-subscription-dto';

export interface ListPushSubscription$Params {
}

export function listPushSubscription(http: HttpClient, rootUrl: string, params?: ListPushSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PushSubscriptionDto>>> {
  const rb = new RequestBuilder(rootUrl, listPushSubscription.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PushSubscriptionDto>>;
    })
  );
}

listPushSubscription.PATH = '/v0/pushSubscriptions';
